import React from 'react';
import { Navbar } from '../components/senior-living/Navbar';
import { HeroSection } from '../components/senior-living/HeroSection';
import { AwardsSection } from '../components/senior-living/AwardsSection';
import { ResearchSection } from '../components/senior-living/ResearchSection';
import { FeaturesSection } from '../components/senior-living/FeaturesSection';
import { ResultsSection } from '../components/senior-living/ResultsSection';
import { ApproachSection } from '../components/senior-living/ApproachSection';
import { FAQSection } from '../components/senior-living/FAQSection';
import { BottomCTASection } from '../components/senior-living/BottomCTASection';
export function SeniorLivingLandingPage() {
  return <div className="flex w-full min-h-full flex-col bg-white" data-id="element-132" data-mp="2jgkviagvw9cz">
      <Navbar data-id="element-133" data-mp="2oh8xfr6nialz" />
      <main data-id="element-134" data-mp="2ohs3oamxvak6">
        <HeroSection data-id="element-135" data-mp="2oi0k2ci9sy04" />
        <AwardsSection data-id="element-136" data-mp="2oitsdhwvnvkd" />
        <ResearchSection data-id="element-137" data-mp="2of5zmkz9bd6p" />
        <ResultsSection data-id="element-138" data-mp="2si2lckk3fpev" />
        <FeaturesSection data-id="element-139" data-mp="2sjdnkfxw4p3v" />
        <ApproachSection data-id="element-140" data-mp="2sghp8qi4ryew" />
        <BottomCTASection data-id="element-141" data-mp="2c25jwvfzy9xi" />
        <FAQSection data-id="element-142" data-mp="2c2fbuoklqr5u" />
      </main>
    </div>;
}